module.exports = "addPadding {\n  padding: 2em; }\n"